<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Logs de auditoría</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <div class="table-responsive">
                    <table>
                        <thead>
                            <tr>
                                <th>Evento</th>
                                <th>Fecha</th>
                                <th>Usuario</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(registro, index) in registros" :key="index">
                                <td>{{ registro.evento }}</td>
                                <td>{{ registro.created_at }}</td>
                                <td>{{ registro.nombre_usuario }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="modal-buttons">
            <button class="btn-danger" type="button" @click="$emit('cerrar')"><i class="fa fa-ban"></i><span>Cerrar</span></button>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        id : {
            required : false,
            default : ''
        }
    },
    methods : {
        cargarLogs : function () {
            let that = this;
            if (this.id !== '' && this.id != null) {
                axios.get(url + '/' + this.id + '/logs').then(function (response) {
                    that.registros = response.data;
                });
            }
        }
    },
    data : function () {
        return {
            registros : []
        };
    },
    mounted : function () {
        this.cargarLogs();
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/ecas-coparn/LogsEcasCoparn.vue